<div>

  <!-- ACTION BUTTONS -->
  <div class="noPrint action-buttons">

    <button
      mat-raised-button
      color="primary"
      (click)="excelToExportPostingLabel('Posting_Label_Report')">
      Export
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="printPage4()">
      Print
    </button>

    <button
      mat-raised-button
      color="warn"
      mat-dialog-close>
      Close
    </button>

  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <table class="report-table">

      <!-- HEADER -->
      <thead>

<th colspan="5" class="main-header">
  <span class="left-text">
    Date : {{ currentDate | date:'dd/MM/yyyy' }}
  </span>

  <span style="text-align: center; font-weight: bold; background: #f9f9f9;">
    हिंदुस्थान प्रकाशन संस्था विवेक साप्ताहिक
  </span>
</th>

        <!-- BOOK NAME ROW -->
        <!-- <tr> -->
         <tr>
  <th colspan="5" style="text-align: center; font-weight: bold; background: #f9f9f9;">
    Book Name : {{ uniqueBookNames }}
  </th>
</tr>
        <!-- </tr> -->

        <!-- COLUMN HEADERS -->
        <tr>
          <th>Booking Date</th>
          <th>Name</th>
          <th>Address</th>
          <th>Mobile</th>
          <th>Copies</th>
          <!-- <th></th> -->
        </tr>

      </thead>

      <!-- BODY -->
      <tbody>

        <tr *ngFor="let item of flatData; let i = index">

          <td>{{ item.booking_date | date:'dd/MM/yyyy' }}</td>
          <td>{{ item.name }}</td>
          <td>{{ getFullAddress(item) }}</td>
          <td>{{ item.mobile_no }}</td>
          <td>{{ item.book_copies }}</td>
          <!-- <td></td> -->

        </tr>

        <tr></tr>

        <!-- TOTAL ROW -->
        <tr *ngIf="flatData.length > 0" style="font-weight: bold; background: #f3f3f3;">
          <td colspan="4" style="text-align: right;">TOTAL</td>
          <td>{{ totalBookCopies }}</td>
          <!-- <td></td> -->
        </tr>

      </tbody>

    </table>

  </div>

</div>